import React, {useEffect} from 'react';

import RenditionDroplet from 'Icons/RenditionDroplet';
import {useUserContext} from 'Contexts/UserContext/UserContext';

import {useHistory} from 'react-router-dom';
import {GradientShadowButton} from 'Components/GradientShadowButton/GradientShadowButton';

export const SignIn: React.FC<React.PropsWithChildren<unknown>> = () => {
    const {signIn, user} = useUserContext();
    const history = useHistory();

    useEffect(() => {
        if (user) {
            history.push('/');
        }
    }, [user, history]);

    return (
        <div className="flex h-screen w-full flex-col items-center justify-center gap-8 overflow-hidden bg-white">
            <RenditionDroplet width={45} height={45} />
            <GradientShadowButton onClick={signIn} disabled={!!user}>
                Sign in with Google
            </GradientShadowButton>
        </div>
    );
};
